import { Image } from './Styled'
import { formatDate } from 'utils/timeFormat'
import { fetchPostAdEvent, SchemaOholoMaterialShow } from 'api'
import { useCallback } from 'react'

interface CarouselItemProps extends SchemaOholoMaterialShow {
  onClick?: (ev: React.MouseEvent) => void
}

export default function CarouselItem({ onClick, ...info }: CarouselItemProps) {
  const handleAdClick = useCallback(
    (ev: React.MouseEvent) => {
      onClick?.(ev)
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: info.id,
        material_name: info.name,
        oholo_site_id: info.site_type,
        oholoer_id: info.oholoer_id,
        oholoer_link: info.oholoer_link,
        oholoer_name: info.oholoer_name,
      })
      window.open(info?.link, '_blank')
    },
    [info.id, info?.link, info.name, info.oholoer_id, info.site_type, info.oholoer_link, info.oholoer_name, onClick]
  )
  return <Image src={info.icon_path} onClick={handleAdClick} />
}
